import React from "react";
import { Dialog, Button } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { FaArrowCircleLeft } from "react-icons/fa";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const VoucherDetailsDialog = ({ open, handleClose, showDetails }) => {
  // console.log(showDetails);
  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <FaArrowCircleLeft />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Debit Voucher List
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              OK
            </Button>
          </Toolbar>
        </AppBar>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>No</TableCell>
                <TableCell>Voucher No</TableCell>
                <TableCell>Discount</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Bill Amount</TableCell>
                <TableCell>Sale Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {showDetails.map((detail, i) => (
                <TableRow
                  key={detail?.created_at}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {i + 1}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {detail?.id}
                  </TableCell>
                  <TableCell> {detail?.discount} </TableCell>
                  <TableCell> {detail?.total} </TableCell>
                  <TableCell> {detail?.bill}</TableCell>
                  <TableCell>{detail?.created_at.split("T")[0]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Dialog>
    </>
  );
};

export default VoucherDetailsDialog;
